// extracted by mini-css-extract-plugin
module.exports = {"locate":"locate_locate__33AEr"};